import { MaterialUIApp } from './lib/material-ui-components'
// TEST: Inizializzazione A-Frame temporaneamente disabilitata per debug
// import './views/aframe-init'
import { appBase } from './lib/routes'
import { Home } from './views/home'
import { NotFound } from './views/notfound'
import { Universal3DExperience } from './views/universal-3d-experience'
import { Login } from './views/login'
import { LoginDisplay } from './views/login-display'
import { Blocked } from './views/blocked'
import { ProtectedRoute } from './lib/protected-route'
import { AuthSystem } from './lib/auth-system'
import { ExperienceViewer } from './views/experience-viewer'
import { PublicExperienceViewer } from './views/public-experience-viewer'
import { MovingExperience } from './views/moving-experience'
import { OlogrammaExperience } from './views/ologramma-experience'
import { DemoARExperience } from './views/demo-ar-experience'

declare let React: any
declare let ReactDOM: any
declare let ReactRouterDOM: any

const { BrowserRouter, Route, Switch } = ReactRouterDOM

class App extends React.Component {
  render() {
    // Calcola il base path dentro il render per evitare problemi di inizializzazione
    const base = appBase()

    console.log('🔧 App - base path:', base)
    console.log('🔧 App - location.pathname:', location.pathname)
    console.log('🔧 App - base path starts with:', location.pathname.startsWith(base))

    return (
      <BrowserRouter>
        <Switch>
          {/* Route pubblica per visualizzazione QR code - gestisce sia con che senza base path */}
          {/* Route con base path (se presente) */}
          {base && (
            <Route
              exact
              path={`${base}/a9k7m3p2x8w5q1n6j4h0r9t2v7c5b8d4f1g3k6`}
              component={LoginDisplay}
            />
          )}
          {/* Route senza base path (sempre presente per compatibilità) */}
          <Route
            exact
            path="/a9k7m3p2x8w5q1n6j4h0r9t2v7c5b8d4f1g3k6"
            component={LoginDisplay}
          />

          {/* Route pubblica per pagina di blocco (senza accesso al login) */}
          {/* Route con base path (se presente) */}
          {base && (
            <Route
              exact
              path={`${base}/blocked`}
              component={Blocked}
            />
          )}
          {/* Route senza base path (sempre presente per compatibilità) */}
          <Route
            exact
            path="/blocked"
            component={Blocked}
          />

          {/* Route di login con URL dinamico - PUBBLICA */}
          {/* Route con base path (se presente) */}
          {base && (
            <Route
              path={`${base}/login/:hash`}
              component={({ match, location, history }: any) => {
                // La pagina di login è sempre accessibile
                // La validazione dell'URL serve solo per mostrare informazioni corrette
                return <Login location={location} history={history} />
              }}
            />
          )}
          {/* Route senza base path (sempre presente per compatibilità) */}
          <Route
            path="/login/:hash"
            component={({ match, location, history }: any) => {
              // La pagina di login è sempre accessibile
              return <Login location={location} history={history} />
            }}
          />

          {/* Route per QR codes - PROTETTA */}
          <Route
            exact
            path={`${base}/qr/:experienceId`}
            component={(props: any) => {
              const { match, location, history } = props
              const authSystem = AuthSystem.getInstance()
              if (!authSystem.isTokenValid()) {
                history.push(`${base}/blocked`)
                return null
              }
              const experienceId = match.params.experienceId
              const searchParams = new URLSearchParams(location.search)
              const newSearch = new URLSearchParams()
              newSearch.set('exp', experienceId)
              searchParams.forEach((value: string, key: string) => { newSearch.set(key, value) })
              history.replace(`${base}/3d-experience?${newSearch.toString()}`)
              return null
            }}
          />
          {/* Route alternativa senza base path per QR codes */}
          {base && (
            <Route
              exact
              path="/qr/:experienceId"
              component={(props: any) => {
                const { match, location, history } = props
                const authSystem = AuthSystem.getInstance()
                if (!authSystem.isTokenValid()) {
                  history.push(`${base}/blocked`)
                  return null
                }
                const experienceId = match.params.experienceId
                const searchParams = new URLSearchParams(location.search)
                const newSearch = new URLSearchParams()
                newSearch.set('exp', experienceId)
                searchParams.forEach((value: string, key: string) => { newSearch.set(key, value) })
                history.replace(`${base}/3d-experience?${newSearch.toString()}`)
                return null
              }}
            />
          )}

          {/* Esperienze dedicate con URL personalizzati - PROTETTE */}
          <Route
            exact
            path={`${base}/experience/:experienceId`}
            component={(props: any) => <ProtectedRoute {...props} component={ExperienceViewer} />}
          />
          {/* Route alternativa senza base path */}
          {base && (
            <Route
              exact
              path="/experience/:experienceId"
              component={(props: any) => <ProtectedRoute {...props} component={ExperienceViewer} />}
            />
          )}

          {/* Esperienze 3D PUBBLICHE senza token - parallele a /experience */}
          <Route
            exact
            path={`${base}/demo/:experienceId`}
            component={PublicExperienceViewer}
          />
          {base && (
            <Route
              exact
              path="/demo/:experienceId"
              component={PublicExperienceViewer}
            />
          )}

          {/* ═══════ Route PUBBLICHE hardcoded (nessun token) ═══════ */}

          {/* Route /moving - Esperienza 3D PUBBLICA hardcoded (bleirot), nessun token */}
          <Route exact path={`${base}/moving`} component={MovingExperience} />
          {base && (
            <Route exact path="/moving" component={MovingExperience} />
          )}

          {/* Route /ologramma - Esperienza ologramma PUBBLICA hardcoded (chromakey video), nessun token */}
          <Route exact path={`${base}/ologramma`} component={OlogrammaExperience} />
          {base && (
            <Route exact path="/ologramma" component={OlogrammaExperience} />
          )}

          {/* Route /demo - Esperienza AR PUBBLICA hardcoded (genericAR con target e video fissi) */}
          <Route exact path={`${base}/demo`} component={DemoARExperience} />
          {base && (
            <Route exact path="/demo" component={DemoARExperience} />
          )}

          {/* ═══════ Route PROTETTE (richiedono token) ═══════ */}

          {/* Home - PROTETTA dal token */}
          <Route
            exact
            path={`${base}/`}
            component={(props: any) => <ProtectedRoute {...props} component={Home} />}
          />
          {/* Route alternativa senza base path */}
          {base && (
            <Route
              exact
              path="/"
              component={(props: any) => <ProtectedRoute {...props} component={Home} />}
            />
          )}

          {/* Route 3d-experience - PROTETTA */}
          <Route
            exact
            path={`${base}/3d-experience`}
            component={(props: any) => <ProtectedRoute {...props} component={Universal3DExperience} />}
          />
          {/* Route alternativa senza base path */}
          {base && (
            <Route
              exact
              path="/3d-experience"
              component={(props: any) => <ProtectedRoute {...props} component={Universal3DExperience} />}
            />
          )}

          {/* Route di fallback */}
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    )
  }
}

const render = () => {
  document.body.insertAdjacentHTML('beforeend', '<div id="root"></div>')
  ReactDOM.render(
    <MaterialUIApp>
      <App />
    </MaterialUIApp>,
    document.getElementById('root')
  )
}

export { render }
